(() => {
  const mountProduct = () => {
    const block = document.querySelector('[data-rec-ready-when-product]');
    if (!block || block.dataset.recMounted === 'true') return;
    const buttons = Array.from(document.querySelectorAll('[data-atc-form]'));
    const atc = buttons.find((button) => {
      if (button.closest('.ftf-sticky-atc, #ftf-mini_cart, [class*="quick"], [class*="drawer"]')) return false;
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }) || buttons[0];
    if (!atc) return;
    const form = atc.closest('form');
    const anchor = form || atc.closest('.ftf-product-form__buttons') || atc.parentElement;
    if (!anchor?.parentElement) return;
    anchor.insertAdjacentElement('afterend', block);
    block.hidden = false;
    block.dataset.recMounted = 'true';
  };

  const setupCartRefresh = () => {
    const block = document.querySelector('[data-rec-ready-when-cart]');
    if (!block || block.dataset.recRefreshBound === 'true') return;
    block.dataset.recRefreshBound = 'true';
    const sectionId = block.dataset.sectionId;
    if (!sectionId) return;
    let timer = 0;
    let refreshing = false;

    const refresh = async () => {
      if (refreshing) return;
      refreshing = true;
      try {
        const url = `${window.Shopify?.routes?.root || '/'}cart?section_id=${encodeURIComponent(sectionId)}`;
        const response = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-rec-ready-when-cart]');
        const current = document.querySelector(`[data-rec-ready-when-cart][data-section-id="${CSS.escape(sectionId)}"]`);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          current.hidden = false;
        } else if (!fresh && current) {
          current.innerHTML = '';
          current.hidden = true;
        }
      } catch (_) {
        /* Timing guidance is helpful, never checkout-blocking. */
      } finally {
        refreshing = false;
      }
    };

    const schedule = (delay = 420) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(refresh, delay);
    };

    const cartRoot = document.querySelector('.ftf-section-main-cart');
    if (cartRoot) {
      const observer = new MutationObserver((mutations) => {
        if (refreshing) return;
        const changed = mutations.some((mutation) => mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length));
        if (changed) schedule();
      });
      observer.observe(cartRoot, { childList: true, subtree: true });
    }

    document.addEventListener('change', (event) => {
      if (event.target.closest?.('.ftf-section-main-cart')) schedule(550);
    }, true);
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('.ftf-section-main-cart button, .ftf-section-main-cart a')) schedule(700);
    }, true);
  };

  const boot = () => {
    mountProduct();
    setupCartRefresh();
  };

  const start = () => {
    boot();
    window.setTimeout(mountProduct, 900);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', boot);
})();